import React from 'react'
// components
import { AnimateContainer } from '@/components/commons/container'
import { TagCard } from '@/components/commons/cards/TagCard.component'
import Select from 'react-select'

// styles
import {
  section,
  selectTagContainer,
  tagsContainer,
} from 'styles/v2/pages/profile'
import { ButtonComponent, ButtonEdit } from '@/components/commons/buttons'
import { ProfilePageContext } from 'context/profilePage'

interface Props {
  title: string
  tags?: string[]
  options?: string[]
  editable?: boolean
  onSave?: (tags: string[]) => void
  loading?: boolean
}

interface OptionSelect {
  value: string
  label: string
}

export const TagsSection: React.FC<Props> = ({
  title,
  tags,
  options,
  editable,
  onSave,
  loading,
}) => {
  const { ownProfile } = React.useContext(ProfilePageContext)
  const [isEdditing, setIsEditing] = React.useState(false)

  const [provisionalTags, setProvisionalTags] = React.useState<OptionSelect[]>(
    []
  )

  const edit = () => {
    if (!isEdditing) {
      setIsEditing(true)
    } else {
      setIsEditing(false)
    }
  }

  const onCancel = () => {
    setIsEditing(false)
  }

  const editedTags = provisionalTags.map((tag) => tag.value)

  const showSaveButton = JSON.stringify(editedTags) !== JSON.stringify(tags)

  const save = () => {
    onSave?.(editedTags)
    setIsEditing(false)
  }

  const preSelected = React.useMemo(() => {
    return tags?.map((tag) => ({
      value: tag,
      label: tag,
    }))
  }, [tags])

  const tagOptions = React.useMemo(() => {
    return options?.map((option) => ({
      value: option,
      label: option,
    }))
  }, [options])

  const minHeight =
    (JSON.stringify(editedTags).length / 40) * 30 < 250
      ? 250
      : (JSON.stringify(editedTags).length / 40) * 30

  return (
    <div className={section}>
      <div className="flex justify-space-between items-center mt-30 mb-20">
        <h3 className="text-16 text-primary m-0 mb-12">{title}</h3>
        {editable && <ButtonEdit onClick={edit} />}
      </div>
      {(!isEdditing || !ownProfile) && (
        <div className={tagsContainer}>
          {tags?.map((tag, index) => (
            <div key={index}>
              <AnimateContainer
                type="fadeInTop"
                delay={index * 50}
                setOpacityNone={true}
                duration={0.2}
                manualActive={true}
                active={true}
              >
                <TagCard label={tag} />
              </AnimateContainer>
            </div>
          ))}
        </div>
      )}
      {isEdditing && ownProfile && (
        <div style={{ paddingBottom: minHeight + 'px' }}>
          <Select
            defaultValue={preSelected}
            isMulti
            name="colors"
            options={tagOptions}
            className={'basic-multi-select ' + selectTagContainer}
            classNamePrefix="select"
            isClearable={false}
            onChange={(selected) =>
              setProvisionalTags(selected as OptionSelect[])
            }
          />
          {showSaveButton && (
            <div className="flex mt-12 gap-2 full-w">
              <ButtonComponent
                variation="secondary"
                label="Cancel"
                size="xSmall"
                fullWidth
                onClick={onCancel}
                loading={loading}
              />
              <ButtonComponent
                label="Save"
                size="xSmall"
                fullWidth
                onClick={save}
                loading={loading}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
